export default __webpack_public_path__ + "static/media/settings.cf190666.svg";